import { BetStatusId } from '@/models/bet/status/id';

export const betPlayingStatuses = [BetStatusId.Open?.toString()];

export const betCompletedStatuses = [
  BetStatusId.Won?.toString(),
  BetStatusId.Lost?.toString(),
  BetStatusId.CashedOut?.toString(),
  BetStatusId.HalfWon?.toString(),
  BetStatusId.HalfLost?.toString(),
];

export const betWinStatuses = [BetStatusId.Won?.toString()];

export const betLostStatuses = [BetStatusId.Lost?.toString()];
